export default {
  background: '#E5E5E5',
  gray: '#EFEFEF',
  white: '#FFFFFF',
  black: '#000000',
  darkMode: '#595858',
  teal: '#5BBCBD',
  yellow: '#E5A84F',
  primaryPurple: '#8053D7',
  primaryOrange: '#D7753E',
  secondaryOrange: '#E5A84F',
  linkColor: '#61DAFB',
  activeLinkColor: '#FFDC54'
};
